import React, { useCallback } from 'react';

import { Card, CardContent, Grid, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { toCapitalize } from '../../../lib/helpers/helpers';
import { MoreVert } from '@mui/icons-material';
import { deletePatientList } from '../../../lib/api/deletePatientList';
import { useNavigate } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  patientListCard_deprecated: {
    cursor: 'pointer',
    color: theme.palette.admin.main,
    fontWeight: 'bold',
    marginRight: 25,
    marginBottom: 25,
    width: 214,
    height: 50,
    padding: 0,
  },
  patientListCard: {
    cursor: 'pointer',
    color: theme.palette.admin.main,
    fontWeight: 'bold',
    marginRight: 25,
    marginBottom: 25,
    // minWidth: 214, // Changed to min-width for flexibility
    width: 214,
    padding: 0,
    display: 'flex', // Ensure card content aligns properly
    flexDirection: 'column', // Stack content vertically
    justifyContent: 'center', // Center content vertically for smaller items
    height: 50,
  },
  patientListCardMoreButton: {
    marginTop: -5,
    marginRight: -10,
    padding: 0,
  },
  patientListCardText: {
    wordBreak: 'break-word', // Ensure long words wrap
    paddingRight: '36px', // Provide space for the more button
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  textBoxSpacing: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '2%',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

const PatientListsIndividualCard = ({ listItem, refetch }) => {
  const classes = useStyles();
  let navigate = useNavigate();
  const { id, list_name } = listItem;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const managePatientList = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const deleteList = useCallback((event) => {
    const confirm = window.confirm('Confirm Deletion: ' + list_name);
    if (confirm) {
      //todo - support delete
      // console.log('List: ' + id)
      deletePatientList(id).then(() => {
        setAnchorEl(null);
        refetch();
      });
    }
  }, []);

  const editList = useCallback((event) => {
    //todo - support edit
  }, []);

  return (
    <>
      <Card
        key={'patient_list_' + id}
        className={classes.patientListCard}
      >
        <CardContent>
          <Grid
            container
            justifyContent={'space-between'}
          >
            <div className={classes.textBoxSpacing}>
              <Tooltip
                title={list_name}
                arrow
              >
                <Grid
                  item
                  onClick={() => navigate('../patients/list/' + id, { replace: true })}
                  className={classes.patientListCardText}
                >
                  {toCapitalize(list_name)}
                </Grid>
              </Tooltip>
              <Grid
                item
                className={classes.patientListCardMoreButton}
              >
                <IconButton
                  onClick={managePatientList}
                  size={'small'}
                  style={{ marginRight: '10%', marginTop: '5px' }}
                >
                  <MoreVert />
                </IconButton>
              </Grid>
            </div>
          </Grid>
        </CardContent>
      </Card>

      <Menu
        id="card-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={editList}
          disabled={true}
        >
          Edit
        </MenuItem>
        <MenuItem onClick={deleteList}>Delete</MenuItem>
      </Menu>
    </>
  );
};

export default PatientListsIndividualCard;
